import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';
import { get } from 'lodash';
import MainPageForm from './MainPageForm/MainPageForm';
import { FETCH_DESIGN, CHANGE_DESIGN } from '../../redux/Design';
import { connect } from 'react-redux';
import pick from 'lodash/pick';

class ContentContainer extends PureComponent {
  componentDidMount() {
    this.props.fetchDesign();
  }

  handleMainPageFormSubmit = values => {
    return new Promise((resolve, reject) => {
      this.props.changeDesign({ design: values, promise: { resolve, reject } });
    });
  }

  render() {
    const { design } = this.props;
    const initialValues = pick(design, [
      'id', 'header_title', 'header_description', 'header_slogan', 'logo', 'subdomain'
    ]);

    return (
      <Route exact path="/dashboard/content/main-page">
        <MainPageForm
          design={design}
          initialValues={initialValues}
          onSubmit={this.handleMainPageFormSubmit}
        />
      </Route>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    design: get(state, 'design'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDesign: () => dispatch(FETCH_DESIGN()),
    changeDesign: changedData => dispatch(CHANGE_DESIGN(changedData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentContainer);
